import type { RouteRecordRaw } from 'vue-router';
import { useBrandComponent } from '@/composables/useBrandComponent';
import { ACTIVITY_LOGS_ROUTE_PATH } from '../config/activityLogs';

const activityLogsComponent = useBrandComponent('modules/activity-logs-v2/views/ActivityLogsView.vue');
const activityLogsMeta = {
    requiresAuth: true,
    title: 'Folios',
    requiresPermission: 'brokerin',
    minLevel: 20,
    requiresSystemPermission: 'my_folios'
};

// v2 queda fija (cierre de rediseño): VITE_DISABLE_MY_FOLIOS se elimina, ya no
// hay forma de apagar el módulo por variable de entorno.
export const activityLogsRoutes: RouteRecordRaw[] = [
    {
        path: ACTIVITY_LOGS_ROUTE_PATH,
        name: 'Mis Folios v2',
        component: activityLogsComponent,
        meta: activityLogsMeta
    },
    {
        path: `${ACTIVITY_LOGS_ROUTE_PATH}/:hash`,
        name: 'Mis Folios v2 Detalle',
        component: activityLogsComponent,
        meta: activityLogsMeta
    },
    {
        path: '/folios',
        name: 'Folios Local',
        component: activityLogsComponent,
        meta: activityLogsMeta
    },
    {
        path: '/folios/:hash',
        name: 'Folios Local Detalle',
        component: activityLogsComponent,
        meta: activityLogsMeta
    }
];
